import { atom } from 'nanostores';

/**
 * Live credit balance pushed by the server in chat `message-metadata` right after a turn's
 * deduction commits. Lets the sidebar reflect the new balance instantly (no refetch, no race).
 * `null` until the first turn of a session; displays then fall back to the fetched subscription.
 */
export const $liveCredits = atom<number | null>(null);

export function setLiveCredits(remaining: number) {
  $liveCredits.set(remaining);
}
